// extracted by mini-css-extract-plugin
export default {"BreakpointFromMedium":"(min-width: 640px)","CG-200":"#AEB7C0","CG-600":"#516272","CG-800":"#333D47","W-0":"#FFFFFF","strikedOutPrice":"G2593c3","primaryPrice":"Gd76f36"};